export interface ProjectsArray {
  id: number;
  projectNumber: string;
  projectName: string;
  clientName: string;
  startDate: string;
  endDate: string;
  isUnproductive: boolean;
  isDairen: boolean;
}

export type ProjectsGetResponse = {
  projects: ProjectsArray[];
  totalPages: number;
};

export const EmptyProjectsGetResponse: ProjectsGetResponse = {
  projects: [
    {
      id: 0,
      projectNumber: '',
      projectName: '',
      clientName: '',
      startDate: '',
      endDate: '',
      isUnproductive: false,
      isDairen: false,
    },
  ],
  totalPages: 0,
};
